import React, {useMemo} from 'react'
import LoginPage from 'components/pages/Auth/LoginPage/LoginPage';
import SwitchTeamPage from 'components/pages/Auth/SwitchTeamPage/SwitchTeamPage';
import LogoutPage from 'components/pages/Auth/LogoutPage/LogoutPage';
import ForgotPage from 'components/pages/Auth/ForgotPage/ForgotPage';
import ResetPage from 'components/pages/Auth/ResetPage/ResetPage';
import BannerWrapper from 'components/templates/Wrappers/Banners/BannerWrapper/BannerWrapper';
import WelcomeBanner from 'components/organisms/Banners/WelcomeBanner/WelcomeBanner';
import utils from 'helpers/utils';
import GrantPage from 'components/pages/Auth/GrantPage/GrantPage';

export default function useAuthRoutes () {
  return useMemo(() => {
    const route = [
      {
        path: 'login',
        element: <LoginPage/>,
        handle: {
          title: 'Log in',
          auth: utils.createAuth({mustLogin: false})
        }
      },
      {
        path: 'forgot',
        element: <ForgotPage/>,
        handle: {
          title: 'Forgot password',
          auth: utils.createAuth({ mustLogin: false })
        }
      },
      {
        path: 'grant/:uuid',
        element: <GrantPage/>,
        handle: {
          title: 'Authorize',
          auth: utils.createAuth({ mustLogin: true })
        }
      },
      {
        path: 'reset/:hash',
        element: <ResetPage/>,
        handle: {
          title: 'Reset password',
          auth: utils.createAuth({ mustLogin: false })
        }
      },
      {
        path: 'logout',
        element: <LogoutPage />,
        handle: {
          title: 'Log out',
          auth: utils.createAuth({ mustLogin: false })
        }
      },
      {
        path: 'teams',
        element: <SwitchTeamPage />,
        handle: {
          title: 'Teams',
          auth: utils.createAuth({ attribute: 'team.switch' })
        },
        children: [{
          path: ':teamId',
          handle: {
            auth: utils.createAuth({ attribute: 'team.switch' })
          },
          element: <React.Fragment />,
        }]
      }
    ];

    return {
      WrapperComponent: ({children}) => <BannerWrapper banner={<WelcomeBanner />}>{children}</BannerWrapper>,
      route: route
    };
  }, []);
};
